'use client';

import SearchForm from '@/components/Search/SearchForm';
import Flex from '@/components/ui/Flex';
import { useTranslations } from 'next-intl';
import CategoryFilter from './CategoryFilter';
import EventTimeFilter from './EventTimeFilter';
import SortByField from './SortByField';

const Filters = () => {
  const t = useTranslations('entryIndex');
  return (
    <Flex spacing="md">
      <SearchForm />
      <EventTimeFilter />
      <SortByField />
      <CategoryFilter
        filters={[
          { label: t('genreCategory'), name: 'genreCategory' },
          { label: t('venueCategory'), name: 'venueCategory' },
          { label: t('programCategory'), name: 'programCategory' },
          { label: t('eventTypeCategory'), name: 'eventTypeCategory' },
          { label: t('accessibilityCategory'), name: 'accessibilityCategory' },
        ]}
      />
    </Flex>
  );
};

export default Filters;
